import React from 'react'

type Props = {
    className?: string
}

export const CheckIcon = (props: Props) => {
    const { className = "h-5 w-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="M20 6 9 17l-5-5"/>
        </svg>
    )
}
